// Getters
export const commercial = (state) => {
  return state.commercial.data || []
}
export const commercialLoading = (state) => {
  return state.commercial.loading
}
export const commercialLastUpdate = (state) => {
  return state.commercial.lastUpdate
}

export const historicalSenders = (state) => {
  return state.historicalSenders.data || []
}
export const historicalSendersLoading = (state) => {
  return state.historicalSenders.loading
}
export const historicalSendersLastUpdate = (state) => {
  return state.historicalSenders.lastUpdate
}

export const historicalConversations = (state) => {
  return state.historicalConversations.data || []
}
export const historicalConversationsLoading = (state) => {
  return state.historicalConversations.loading
}
export const historicalConversationsLastUpdate = (state) => {
  return state.historicalConversations.lastUpdate
}

export const googleStoreToken = (state) => {
  return state.googleStoreToken.data || []
}
export const googleStoreTokenLoading = (state) => {
  return state.googleStoreToken.loading
}
export const googleStoreTokenLastUpdate = (state) => {
  return state.googleStoreToken.lastUpdate
}

export const historicalConversation = (state) => {
  return state.historicalConversation.data || []
}
export const historicalConversationLoading = (state) => {
  return state.historicalConversation.loading
}
export const historicalConversationLastUpdate = (state) => {
  return state.historicalConversation.lastUpdate
}
export const sendWhatsappMessage = (state) => {
  return state.sendWhatsappMessage.data || []
}
export const sendWhatsappMessageLoading = (state) => {
  return state.sendWhatsappMessage.loading
}
export const sendWhatsappMessageLastUpdate = (state) => {
  return state.sendWhatsappMessage.lastUpdate
}

export const permissions = (state) => {
  return state.permissions.data || []
}
export const permissionsLoading = (state) => {
  return state.permissions.loading
}
export const permissionsLastUpdate = (state) => {
  return state.permissions.lastUpdate
}

export const statusPermissions = (state) => {
  return state.statusPermissions.data || []
}
export const statusPermissionsLoading = (state) => {
  return state.statusPermissions.loading
}
export const statusPermissionsLastUpdate = (state) => {
  return state.statusPermissions.lastUpdate
}

export const integrateWithCalendar = (state) => {
  return state.integrateWithCalendar.data || []
}
export const integrateWithCalendarLoading = (state) => {
  return state.integrateWithCalendar.loading
}
export const integrateWithCalendarLastUpdate = (state) => {
  return state.integrateWithCalendar.lastUpdate
}

export const statusAllSdr = (state) => {
  return state.statusAllSdr.data || []
}
export const statusAllSdrLoading = (state) => {
  return state.statusAllSdr.loading
}
export const statusAllSdrLastUpdate = (state) => {
  return state.statusAllSdr.lastUpdate
}

export const settings = (state) => {
  return state.settings.data || []
}
export const settingsLoading = (state) => {
  return state.settings.loading
}
export const settingsLastUpdate = (state) => {
  return state.settings.lastUpdate
}

export const internalVariables = (state) => {
  return state.internalVariables.data || []
}
export const internalVariablesLoading = (state) => {
  return state.internalVariables.loading
}
export const internalVariablesLastUpdate = (state) => {
  return state.internalVariables.lastUpdate
}

export const excelVariables = (state) => {
  return state.excelVariables.data || []
}
export const excelVariablesLoading = (state) => {
  return state.excelVariables.loading
}
export const excelVariablesLastUpdate = (state) => {
  return state.excelVariables.lastUpdate
}

